var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('vue-ueditor-wrap',{attrs:{"editor-id":"editor","config":_vm.editorConfig,"editorDependencies":['ueditor.config.js', 'ueditor.all.js']},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }